module.exports = __webpack_public_path__ + "img/TECNOLOGIA-ERTIGA-5.9ee988e5.jpg";